const rawBaseUrl = process.env.REACT_APP_API_BASE_URL ?? "";
const defaultBaseUrl =
  process.env.NODE_ENV === "development" ? "" : "/api";

const normalizeBaseUrl = (value: string) =>
  value.endsWith("/") && value.length > 1 ? value.slice(0, -1) : value;

export const API_BASE_URL =
  rawBaseUrl !== "" ? normalizeBaseUrl(rawBaseUrl) : defaultBaseUrl;

export const DATASET_NAME =
  process.env.REACT_APP_DATASET_NAME ?? "AMU dataset";

export const LEGAL_TEXT =
  process.env.REACT_APP_LEGAL_TEXT ??
  'Graph generated with the AMU visualization dashboard. The software is provided "AS IS" without any warranty or liability.';
